angular.module('logbook')
  .factory('tagValueFactory', [function() {
    var service = {};

    service.data = {};

    service.loadTagValues = function(source, target, selectedIds) {
       console.log("loadTagValues: selectedIds " + JSON.stringify(selectedIds));
       source._embedded.tagValues.forEach(function(tagValue) {
          var tagHref = tagValue.tag._links.self.href.replace(/\{.*\}/,'');
          if( !target[tagHref] )
          {
             target[tagHref] = [];
             target[tagHref].selected = [];
          }
          target[tagHref].push(tagValue);
          if( selectedIds && selectedIds.indexOf(tagValue.id.toString()) >= 0 )
             target[tagHref].selected.push(tagValue);
       });
    };
    return service;
  }]);
